"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
var _excluded = ["children", "query"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/**
 * @deprecated
 * Official support for React Apollo render prop components ended in March 2020.
 * This component is now provided by the @sm/apollo-clients package for backwards compatibility,
 * but it will not receive any feature updates or bug fixes.
 * You should use the `useQuery` hook instead.
 */
var Query = function Query(props) {
  var children = props.children,
    query = props.query,
    options = _objectWithoutProperties(props, _excluded);
  var result = (0, _client.useQuery)(query, options);
  return result ? children(result) : null;
};
var _default = exports.default = Query;
module.exports = exports.default;